module.exports = __webpack_public_path__ + "img/s5-20.7fe98bfc.png";